import React from "react";
import Image from "next/image";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

type IconCard = {
  id: string;
  icon: string;
  title: string;
  description: string;
};

type IconCardGridProps = {
  iconCards: IconCard[];
  columns: number;
};

const IconCardGrid: React.FC<IconCardGridProps> = ({ iconCards, columns }) => {
  const isOdd = iconCards.length % columns !== 0;

  return (
    <div
      className="mt-8 flex flex-wrap gap-4"
      style={{
        justifyContent: isOdd ? "center" : "flex-start",
      }}
    >
      {iconCards.map((card, index) => (
        <Card
          key={card.id}
          className={cn(
            "flex flex-col items-center border-none p-4 shadow-none",
            isOdd && index === iconCards.length - 1 && "max-w-xs",
          )}
          style={{
            flex: `1 1 calc(${100 / columns}% - 1rem)`,
            maxWidth: isOdd && index === iconCards.length - 1 ? "25.875rem" : "auto",
          }}
        >
          <CardHeader className="flex flex-col items-center">
            <Image
              width={100}
              height={100}
              src={card.icon}
              alt={card.title}
              className="mb-4 h-12 w-12"
              priority
            />
            <CardTitle className="text-center text-lg">{card.title}</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col items-center">
            <CardDescription className="text-center text-sm text-gray-800">
              {card.description}
            </CardDescription>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default IconCardGrid;
